exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@keyframes fade-in{0%{opacity:0}to{opacity:1}}.edit-comment input[data-v-2c0058be]{width:calc(100% - 1em);height:100%;font-size:.7em;color:#ccc;padding:.5em;margin:0 .5em;border:none;border-bottom:1px solid transparent;transition:.25s;background:transparent}.edit-comment input[data-v-2c0058be]:focus{outline:none;color:#4ecdc4;border-bottom-color:#4ecdc4;box-shadow:0 1px 5px #eee}[class*=left-][data-v-2c0058be]{border-left:4px solid #ccc}.left-1[data-v-2c0058be]{border-left-color:#69d2e7}.left-2[data-v-2c0058be]{border-left-color:#a7dbd8}.left-3[data-v-2c0058be]{border-left-color:#e0e4cc}.left-4[data-v-2c0058be]{border-left-color:#f38630}.left-5[data-v-2c0058be]{border-left-color:#fa6900}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-2c0058be&scoped=true!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/EditComment.vue
// module id = 25
// module chunks = 0